module.exports = __webpack_public_path__ + "img/icon_ctj.0b4a482e.png";